// __DELAY_VIEW__ (2026-10-30) the pure half of the Load Details "Delay" tab and the delay badge (no imports, so
// sim/delaybreakdown.test.mjs evaluates this very source). The numbers come from the hub (GET
// /api/board/delay-breakdown/<id>), which works them out with billing's own calculation; nothing here computes a delay.
// Henry: "The board in hauling needs a good breakdown of delay types ... On the Trello board I let users add comments,
// which I review with the delay analyzer later to see how much billable time."

export const SOURCE_LABEL = {
  geofence: 'geofence (GPS)',
  driver: 'driver tap',
  office: 'office edit',
  address_fix: 'address fix re-check',
};

export const sourceLabel = (src) => (src ? (SOURCE_LABEL[src] || String(src)) : '');

export const fmtMin = (n) => {
  if (n === null || n === undefined || n === '' || Number.isNaN(Number(n))) return '—';
  return Math.round(Number(n)) + ' min';
};

export const fmtMoney = (n) => {
  if (n === null || n === undefined || n === '' || Number.isNaN(Number(n))) return '—';
  return '$' + Number(n).toFixed(2);
};

// A timestamp from the hub: timestamptz as given, naive-UTC already carries its Z (delay_view.iso).
export const fmtWhen = (iso) => {
  if (!iso) return '—';
  const d = new Date(String(iso));
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

// The badge text: '⏱ 45m', '⏱ 1h 07m'. '' when there is nothing billable.
export const badgeText = (min) => {
  const m = Math.round(Number(min) || 0);
  if (m <= 0) return '';
  if (m < 60) return '⏱ ' + m + 'm';
  const r = m % 60;
  return '⏱ ' + Math.floor(m / 60) + 'h ' + (r < 10 ? '0' : '') + r + 'm';
};

export const largerOfText = (b) => {
  if (!b || !b.larger_of) return 'no booked delay and no GPS billable dwell';
  if (b.larger_of === 'booked') return 'booked delay is the larger, so it is billed (the GPS dwell is the same waiting)';
  if (b.larger_of === 'gps') return 'GPS billable dwell is the larger, so it is billed (the booked delay is the same waiting)';
  return 'booked delay and GPS billable dwell are equal';
};

// How the hub reads a comment ({load: 25, unload: 25}) -> 'load 25 · unload 25'
export const readAsText = (r) => {
  if (!r || typeof r !== 'object') return '';
  return ['load', 'unload', 'delay'].filter((k) => r[k]).map((k) => k + ' ' + r[k]).join(' · ');
};

export const reportedText = (rep) => {
  if (!rep) return '';
  const parts = [];
  if (rep.load_min) parts.push('load ' + rep.load_min + ' min');
  if (rep.unload_min) parts.push('unload ' + rep.unload_min + ' min');
  if (rep.delay_min) parts.push('delay ' + rep.delay_min + ' min');
  return parts.join(' · ');
};

export const REPORT_SOURCE = { trello_card: 'typed on the Trello card', trello_comment: 'Trello comment' };

// The hub page for an adjustment: #open-delay=<id> (Hauling Board tab, this job's breakdown) or #open-analyzer (the
// Trello Cards tab). The session goes with it, as the board's other hub links do (hubDrafts.draftHubUrl).
export const hubDelayUrl = (hub, loadId, what, accessToken, refreshToken) => {
  const frag = what === 'analyzer' ? '#open-analyzer' : '#open-delay=' + encodeURIComponent(String(loadId || ''));
  if (!accessToken) return hub + '/' + frag;
  return hub + '/?token=' + encodeURIComponent(accessToken) + '&refresh_token=' + encodeURIComponent(refreshToken || '') + frag;
};

// The panel's top line: billable minutes and dollars, as billing computes them.
export const billableHeadline = (b) => {
  if (!b) return '';
  const m = Math.round(Number(b.delay_time_min) || 0);
  if (m <= 0) return 'No billable delay';
  return m + ' min · ' + fmtMoney(b.amount);
};

// Which stops to show first: customer stops in the order driven, driver stops last-in-place (kept, never billable).
export const stopKindLabel = (s) => {
  const t = String((s && s.stop_type) || '').toLowerCase();
  if (s && s.driver_stop) return t === 'fuel' ? 'Fuel (driver)' : t === 'break' ? 'Break (driver)' : 'Driver stop';
  return t === 'pickup' ? 'Pickup' : t === 'delivery' ? 'Drop' : (t || 'Stop');
};

export const errorText = (r) => {
  if (!r) return 'The delay breakdown could not be read.';
  if (r.status === 403) return 'The delay breakdown is for the office (dispatch and up).';
  if (r.status === 404) return 'This job is not in the hub.';
  if (r.status === 401) return 'The hub did not accept this sign-in - sign in again.';
  return r.message || 'The delay breakdown could not be read right now - try again.';
};
